import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const DAY_IN_MS = 1000 * 60 * 60 * 24
const WEEK_IN_MS = DAY_IN_MS * 7
const MONTH_IN_MS = DAY_IN_MS * 30

export function formatRelativeTime(value?: string | number | Date | null) {
  if (!value) return 'N/A'

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'N/A'

  const diff = Date.now() - date.getTime()
  if (diff < 0) return 'Just now'
  if (diff < DAY_IN_MS) return 'Today'

  if (diff < WEEK_IN_MS) {
    const days = Math.max(1, Math.floor(diff / DAY_IN_MS))
    return `${days} day${days === 1 ? '' : 's'} ago`
  }

  if (diff < MONTH_IN_MS) {
    const weeks = Math.max(1, Math.floor(diff / WEEK_IN_MS))
    return `${weeks} week${weeks === 1 ? '' : 's'} ago`
  }

  const months = Math.max(1, Math.floor(diff / MONTH_IN_MS))
  return `${months} month${months === 1 ? '' : 's'} ago`
}
